<template>
	<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="80%" top="5vh" :close-on-click-modal="false"
		@close="handleClose" custom-class="new-acc-dialog" :show-header="true">
		<div class="new-acc-son-container">
			<div class="layout-container">
				<!-- 左侧权限信息 -->
				<div class="left-panel">
					<div class="panel-header">
						<h3 class="module-title">权限设置</h3>
					</div>
					<div class="panel-content">
						<div class="permission-tree-section">
							<el-divider content-position="left" style="margin: 12px 0 8px 0;">
								<span style="font-size: 12px; color: #909399;">权限类别</span>
							</el-divider>

							<el-tree :data="permissionTree" :props="treeProps" node-key="id"
								:show-checkbox="mode !== 'view'" :default-expand-all="true" :check-strictly="true"
								:disabled="mode === 'view'" :check-on-click-node="mode !== 'view'"
								:render-content="renderTreeNode" @check="handlePermissionChange"
								@node-click="handleTreeNodeClick" ref="permissionTree" class="custom-permission-tree">
								<template v-slot="{ node, data }">
									<span class="tree-node-content">
										<i v-if="data.icon" :class="data.icon" class="tree-icon"></i>
										<span class="tree-label" :class="{ 'view-mode-label': mode === 'view' }"
											@click="handleLabelClick(node, data, $event)">
											{{ node.label }}
											<span v-if="mode === 'view' && isNodeChecked(node, data)"
												class="view-check-mark">✓</span>
										</span>
									</span>
								</template>
							</el-tree>
						</div>
					</div>
				</div>

				<!-- 中间基本信息 -->
				<div class="middle-panel">
					<div class="form-section">
						<div class="section-header">
							<h3 class="module-title">基本信息</h3>
						</div>
						<el-form ref="basicForm" :model="form" :rules="rules" label-width="120px" size="mini"
							class="basic-form" :disabled="mode === 'view'">
							<el-row>
								<el-col :span="8">
									<el-form-item label="姓名" prop="fullName">
										<el-input v-model="form.fullName" placeholder="请输入姓名"
											:disabled="mode === 'view'"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="性别" prop="sex">
										<el-select v-model="form.sex" placeholder="请选择性别" style="width: 100%;"
											:disabled="mode === 'view'">
											<el-option v-for="item in sexOptions" :key="item.id" :label="item.label"
												:value="item.id"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="出生日期" prop="birthDate">
										<el-input v-model="form.birthDate" placeholder="系统自动计算" disabled></el-input>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row>
								<el-col :span="8">
									<el-form-item label="年龄" prop="birthDate">
										<el-input v-model="age" placeholder="系统自动计算" disabled>
											<template slot="append">岁</template>
										</el-input>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="证件类型" prop="idType">
										<el-select v-model="form.idType" placeholder="请选择证件类型" style="width: 100%;"
											:disabled="mode === 'view'">
											<el-option v-for="item in dictData.certypeEntities" :key="item.id"
												:label="item.name" :value="item.id"
												:disabled="item.id !== 1"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="国籍" prop="nationality">
										<el-select v-model="form.nationality" placeholder="请选择国籍" style="width: 100%;"
											:disabled="mode === 'view'">
											<el-option v-for="item in dictData.country" :key="item.id"
												:label="item.name" :value="item.id"
												:disabled="item.id !== 1"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row>
								<el-col :span="12">
									<el-form-item label="身份证号码" prop="idNumber">
										<el-input v-model="form.idNumber" placeholder="请输入身份证号码"
											@blur="handleIdNumberBlur" :disabled="mode === 'view'"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="联系电话" prop="contactNumber">
										<el-input v-model="form.contactNumber" placeholder="请输入联系电话"
											:disabled="mode === 'view' || mode === 'edit'"></el-input>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row>
								<el-col :span="12">
									<el-form-item label="联系地址" prop="contactAddress">
										<el-input v-model="form.contactAddress" placeholder="更详细精确的地址，如：*小区/门牌号"
											:disabled="mode === 'view'"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="专业职称" prop="professionalTitle">
										<el-select v-model="form.professionalTitle" placeholder="请选择专业职称"
											style="width: 100%;" :disabled="mode === 'view'">
											<el-option-group v-for="group in professionalTitleGroups" :key="group.title"
												:label="group.title">
												<el-option v-for="item in group.options" :key="item.id"
													:label="item.name" :value="item.id"></el-option>
											</el-option-group>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row>
								<el-col :span="8">
									<el-form-item label="农历生日" prop="lunarBirthDate">
										<el-input v-model="form.lunarBirthDate" placeholder="系统自动计算农历生日" readonly>
											<template v-if="mode !== 'view'" slot="append">
												<el-button icon="el-icon-edit" @click="handleManualSelectLunarDate"
													:disabled="mode === 'view' || !form.birthDate"></el-button>
											</template>
										</el-input>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="民族" prop="minZu">
										<el-select v-model="form.minZu" placeholder="请选择民族" style="width: 100%;"
											:disabled="mode === 'view'">
											<el-option v-for="item in dictData.natyEntities" :key="item.id"
												:label="item.name" :value="item.id"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="籍贯" prop="nativePlace">
										<el-cascader v-model="nativePlaceCascader" :options="areaOptions"
											:props="cascaderProps" placeholder="请选择籍贯" style="width: 100%;"
											@change="handleNativePlaceChange" size="mini"
											:disabled="mode === 'view'"></el-cascader>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row>
								<el-col :span="8">
									<el-form-item label="政治面貌" prop="politicalStatus">
										<el-select v-model="form.politicalStatus" placeholder="请选择政治面貌"
											style="width: 100%;" :disabled="mode === 'view'">
											<el-option v-for="item in jobEntities" :key="item.id" :label="item.label"
												:value="item.id"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="血型" prop="bloodType">
										<el-select v-model="form.bloodType" placeholder="请选择血型" style="width: 100%;"
											:disabled="mode === 'view'">
											<el-option v-for="item in dictData.aboTypeEntities" :key="item.id"
												:label="item.name" :value="item.id"
												:disabled="['RH阴性', 'RH阳性'].includes(item.name)"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="婚姻状况" prop="maritalStatus">
										<el-select v-model="form.maritalStatus" placeholder="请选择婚姻状况"
											style="width: 100%;" :disabled="mode === 'view'">
											<el-option v-for="item in dictData.mrgStateEntities" :key="item.id"
												:label="item.name" :value="item.id"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row>
								<el-col :span="8">
									<el-form-item label="学历" prop="educationalBackground">
										<el-select v-model="form.educationalBackground" placeholder="请选择学历"
											style="width: 100%;" :disabled="mode === 'view'">
											<el-option v-for="item in dictData.edulBacdEntities" :key="item.id"
												:label="item.name" :value="item.id"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
						</el-form>
					</div>

					<!-- 证件信息 -->
					<div class="form-section">
						<div class="section-header">
							<h3 class="module-title">证件信息</h3>
						</div>
						<div class="certificate-images">
							<div class="image-item">
								<div class="image-title">工作证件照</div>
								<el-upload class="image-uploader" action="#" :show-file-list="false"
									:before-upload="(file) => handleImageUpload(file, 'workIdPhoto')"
									:disabled="mode === 'view'">
									<div class="image-container">
										<img v-if="form.workIdPhoto" :src="form.workIdPhoto"
											class="certificate-image" />
										<div v-else class="image-empty">
											<i class="el-icon-plus"></i>
											<div>点击上传</div>
										</div>
									</div>
								</el-upload>
							</div>

							<div class="image-item">
								<div class="image-title">资格证电子图片</div>
								<el-upload class="image-uploader" action="#" :show-file-list="false"
									:before-upload="(file) => handleImageUpload(file, 'qcElectronicImage')"
									:disabled="mode === 'view'">
									<div class="image-container">
										<img v-if="form.qcElectronicImage" :src="form.qcElectronicImage"
											class="certificate-image" />
										<div v-else class="image-empty">
											<i class="el-icon-plus"></i>
											<div>点击上传</div>
										</div>
									</div>
								</el-upload>
							</div>

							<div class="image-item">
								<div class="image-title">手工签名图片</div>
								<el-upload class="image-uploader" action="#" :show-file-list="false"
									:before-upload="(file) => handleImageUpload(file, 'signatureImage')"
									:disabled="mode === 'view'">
									<div class="image-container">
										<img v-if="form.signatureImage" :src="form.signatureImage"
											class="certificate-image" />
										<div v-else class="image-empty">
											<i class="el-icon-plus"></i>
											<div>点击上传</div>
										</div>
									</div>
								</el-upload>
							</div>

							<div class="image-item">
								<div class="image-title">执业证电子图片</div>
								<el-upload class="image-uploader" action="#" :show-file-list="false"
									:before-upload="(file) => handleImageUpload(file, 'pcElectronicImage')"
									:disabled="mode === 'view'">
									<div class="image-container">
										<img v-if="form.pcElectronicImage" :src="form.pcElectronicImage"
											class="certificate-image" />
										<div v-else class="image-empty">
											<i class="el-icon-plus"></i>
											<div>点击上传</div>
										</div>
									</div>
								</el-upload>
							</div>
						</div>
					</div>

					<!-- 医保/其他等相关信息 -->
					<div class="form-section">
						<div class="section-header">
							<h3 class="module-title">医保/其他等相关信息</h3>
						</div>
						<el-form ref="otherForm" :model="form" :rules="otherRules" label-width="120px" size="mini"
							class="other-form" :disabled="mode === 'view'">
							<el-row>
								<el-col :span="8">
									<el-form-item label="医保编码" prop="standardCode">
										<el-input v-model="form.standardCode" placeholder="请输入医保编码"
											:disabled="mode === 'view'"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="医保名称" prop="standardName">
										<el-input v-model="form.standardName" placeholder="请输入医保名称"
											:disabled="mode === 'view'"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="执业证号" prop="practicingNumber">
										<el-input v-model="form.practicingNumber" placeholder="请输入执业证号"
											:disabled="mode === 'view'"></el-input>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row>
								<el-col :span="8">
									<el-form-item label="职业日期" prop="practiceDate">
										<el-date-picker v-model="form.practiceDate" type="date" placeholder="请选择职业日期"
											style="width: 100%;" size="mini"
											:disabled="mode === 'view'"></el-date-picker>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="资格证号" prop="qualificationNumber">
										<el-input v-model="form.qualificationNumber" placeholder="请输入资格证号"
											:disabled="mode === 'view'"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="参加工作日期" prop="dateOfEmp">
										<el-date-picker v-model="form.dateOfEmp" type="date" placeholder="请选择参加工作日期"
											style="width: 100%;" size="mini"
											:disabled="mode === 'view'"></el-date-picker>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row>
								<el-col :span="8">
									<el-form-item label="入职时间" prop="entryTime">
										<el-date-picker v-model="form.entryTime" type="date" placeholder="请选择入职时间"
											style="width: 100%;" size="mini"
											:disabled="mode === 'view'"></el-date-picker>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label="离职时间" prop="resignationTime">
										<el-date-picker v-model="form.resignationTime" type="date" placeholder="请选择离职时间"
											style="width: 100%;" size="mini"
											:disabled="mode === 'view'"></el-date-picker>
									</el-form-item>
								</el-col>
							</el-row>
						</el-form>
					</div>
				</div>

				<!-- 右侧科室信息 -->
				<div class="right-panel">
					<!-- 角色权限模块（占30%） -->
					<div class="role-permission-section">
						<div class="panel-header">
							<h3 class="module-title">当前角色权限</h3>
						</div>
						<div class="panel-content">
							<!-- ★★★ 角色树控件：一级多选，node-key 直接绑定后端 19 位字符串 id ★★★ -->
							<el-tree ref="roleTree" :data="roleOptions" :props="roleTreeProps" node-key="id"
								show-checkbox :default-expand-all="true" :check-strictly="true"
								:expand-on-click-node="false" :check-on-click-node="mode !== 'view'"
								:disabled="mode === 'view'" @check="handleRoleTreeCheck" class="role-tree"
								empty-text="暂无角色">
							</el-tree>
						</div>
					</div>

					<!-- 科室信息模块 -->
					<div class="dept-info-section">
						<div class="panel-header">
							<h3 class="module-title">科室信息</h3>
							<el-button v-if="mode !== 'view'" type="primary" size="mini" icon="el-icon-plus"
								@click="handleAddDept" :disabled="isEditingDept">
								添加科室
							</el-button>
						</div>
						<div class="panel-content" style="height: calc(100% - 48px); overflow-y: auto;">
							<el-table :data="deptTableData" border style="width: 100%;" size="mini"
								:height="'calc(100% - 100px)'" :row-key="row => row.id">
								<el-table-column prop="deptName" label="科室名称" min-width="120">
									<template v-slot="{ row }">
										<div v-if="!row.editing || mode === 'view'">
											{{ row.deptName }}
										</div>
										<el-select v-else v-model="row.deptName" placeholder="请选择科室" size="mini"
											style="width: 100%;" @change="handleDeptNameChange(row)">
											<el-option v-for="dept in deptOptions" :key="dept.id" :label="dept.deptName"
												:value="dept.deptName" />
										</el-select>
									</template>
								</el-table-column>

								<el-table-column prop="mainDep" label="主要科室" width="100" align="center">
									<template v-slot="{ row }">
										<span
											v-if="!row.editing || mode === 'view'">{{ row.mainDep === 1 ? '是' : '否' }}</span>
										<el-select v-else v-model="row.mainDep" size="mini" style="width: 100%;"
											:disabled="mode === 'view'" @change="handleMainDeptChange(row)">
											<el-option v-for="item in YNOption" :key="item.id" :label="item.label"
												:value="item.id" />
										</el-select>
									</template>
								</el-table-column>

								<el-table-column label="操作" width="150" align="center" fixed="right"
									v-if="mode !== 'view'">
									<template v-slot="{ row, $index }">
										<div style="display: flex; justify-content: center; gap: 5px;">
											<el-button v-if="!row.editing" type="text" size="mini"
												@click="handleDeptEdit(row, $index)">
												编辑
											</el-button>
											<el-button v-else type="text" size="mini" @click="saveDeptEdit(row, $index)"
												:disabled="!row.deptName">
												保存
											</el-button>

											<el-button v-if="row.editing" type="text" size="mini"
												@click="cancelDeptEdit(row, $index)">
												取消
											</el-button>

											<el-button v-if="!row.editing" type="text" size="mini"
												style="color: #f56c6c;" @click="handleDeptRemove(row, $index)">
												移除
											</el-button>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 添加科室对话框 -->
		<el-dialog title="添加科室" :visible.sync="showAddDeptDialog" width="400px" :before-close="cancelAddDept"
			append-to-body>
			<div class="dept-form">
				<el-form :model="newDept" label-width="80px" size="mini" :disabled="mode === 'view'">
					<el-form-item label="科室名称" prop="deptName"
						:rules="[{ required: true, message: '请选择科室名称', trigger: 'change' }]">
						<el-select v-model="newDept.deptName" placeholder="请选择科室" style="width: 100%;" filterable
							@change="handleDeptNameChange">
							<el-option v-for="dept in deptOptions" :key="dept.id" :label="dept.deptName"
								:value="dept.deptName" />
						</el-select>
					</el-form-item>

					<el-form-item label="主要科室" prop="mainDep">
						<el-radio-group v-model="newDept.mainDep">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="cancelAddDept">取消</el-button>
				<el-button type="primary" size="mini" @click="saveNewDept" :loading="savingDept">确定</el-button>
			</div>
		</el-dialog>

		<!-- 底部按钮 -->
		<div slot="footer" class="dialog-footer">
			<el-button v-if="mode === 'view'" :disabled="true" size="mini">打印</el-button>
			<el-button v-if="mode === 'view'" @click="handleClose" size="mini">关闭</el-button>

			<el-button v-if="mode === 'add' || mode === 'edit'" @click="handleClose" size="mini">取消</el-button>
			<el-button v-if="mode === 'add'" type="primary" :loading="submitting" @click="handleSubmit('add')"
				size="mini">确认添加</el-button>
			<el-button v-if="mode === 'edit'" type="primary" :loading="submitting" @click="handleSubmit('edit')"
				size="mini">保存档案信息</el-button>
		</div>

		<!-- 手动选择农历日期对话框 -->
		<el-dialog title="手动选择农历生日" :visible.sync="lunarDateDialogVisible" width="400px">
			<div class="lunar-date-picker">
				<div style="margin-bottom: 15px;">
					<el-date-picker v-model="selectedLunarDate" type="date" placeholder="请选择农历生日"
						style="width: 100%;" @change="handleLunarDateChange"></el-date-picker>
				</div>
				<div class="lunar-date-actions">
					<el-button @click="lunarDateDialogVisible = false" size="mini">取消</el-button>
					<el-button type="primary" @click="confirmLunarDate" size="mini">确定</el-button>
				</div>
			</div>
		</el-dialog>
	</el-dialog>
</template>

<script>
	import { getLunar } from 'chinese-lunar-calendar'
	import { selectList, dict, updateStatus } from "@/api/staff/staff.js"
	import {
		GetUserInfo,
		roleList,
		updateUser,
		editPwd,
		findAttribute,
		getArea,
		addStaff,
		updateStaff,
		getStaff,
		builderImage
	} from "@/api/user.js"

	export default {
		name: 'NewAccSon',
		props: {
			visible: { type: Boolean, default: false },
			mode: { type: String, default: 'add' },
			clinicName: { type: String, default: '' },
			selectedId: { type: Number, default: null }
		},
		data() {
			const calculateAge = (birthDate) => {
				if (!birthDate) return ''
				const today = new Date()
				const birth = new Date(birthDate)
				let age = today.getFullYear() - birth.getFullYear()
				const monthDiff = today.getMonth() - birth.getMonth()
				if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) age--
				return age
			}

			const calculateLunarBirthDate = (dateStr) => {
				if (!dateStr) return ''
				try {
					let date
					if (typeof dateStr === 'string') {
						if (dateStr.includes('-')) {
							const [year, month, day] = dateStr.split('-').map(Number)
							date = new Date(year, month - 1, day)
						} else if (dateStr.length === 8 && /^\d+$/.test(dateStr)) {
							const year = parseInt(dateStr.substr(0, 4))
							const month = parseInt(dateStr.substr(4, 2))
							const day = parseInt(dateStr.substr(6, 2))
							date = new Date(year, month - 1, day)
						} else return ''
					} else if (dateStr instanceof Date) date = dateStr
					else return ''
					if (isNaN(date.getTime())) return ''
					const lunar = getLunar(date.getFullYear(), date.getMonth() + 1, date.getDate())
					if (lunar) {
						const monthMap = { 1: '正月', 2: '二月', 3: '三月', 4: '四月', 5: '五月', 6: '六月', 7: '七月', 8: '八月', 9: '九月', 10: '十月', 11: '冬月', 12: '腊月' }
						const dayMap = { 1: '初一', 2: '初二', 3: '初三', 4: '初四', 5: '初五', 6: '初六', 7: '初七', 8: '初八', 9: '初九', 10: '初十', 11: '十一', 12: '十二', 13: '十三', 14: '十四', 15: '十五', 16: '十六', 17: '十七', 18: '十八', 19: '十九', 20: '二十', 21: '廿一', 22: '廿二', 23: '廿三', 24: '廿四', 25: '廿五', 26: '廿六', 27: '廿七', 28: '廿八', 29: '廿九', 30: '三十' }
						let monthStr = monthMap[lunar.lunarMonth] || ''
						if (lunar.isLeap) monthStr = '闰' + monthStr
						const dayStr = dayMap[lunar.lunarDate] || ''
						return monthStr + dayStr
					}
					return ''
				} catch (error) {
					console.error('计算农历生日失败:', error)
					return ''
				}
			}

			const validateIdNumber = (rule, value, callback) => {
				if (!value) callback(new Error('请输入身份证号码'))
				else if (!/^\d{17}[\dXx]$/.test(value)) callback(new Error('请输入正确的18位身份证号码'))
				else callback()
			}

			const validatePhone = (rule, value, callback) => {
				if (!value) callback(new Error('请输入联系电话'))
				else if (!/^1[3-9]\d{9}$/.test(value)) callback(new Error('请输入正确的11位手机号码'))
				else callback()
			}

			return {
				form: {
					anesthesiaAuthorization: 0,
					antiTumorPermission: 0,
					antibioticAuthorization: 0,
					birthDate: '',
					bloodType: '',
					chPrescriptionRights: 0,
					clinicId: null,
					contactAddress: '',
					contactNumber: '',
					dateOfEmp: '',
					deptList: [],
					educationalBackground: '',
					entryTime: '',
					fullName: '',
					idNumber: '',
					idType: 1,
					lunarBirthDate: '',
					major: '',
					maritalStatus: '',
					minZu: '',
					nationality: 1,
					nativePlace: '',
					pcElectronicImage: '',
					poisonPermission: 0,
					politicalStatus: '',
					practiceDate: '',
					practicingNumber: '',
					prescriptionRights: 0,
					professionalTitle: '',
					qcElectronicImage: '',
					qualificationNumber: '',
					resignationTime: '',
					roleId: [],       // ★ 严格字符串数组（原始 19 位 id，不做任何转换）
					sex: '',
					signatureImage: '',
					spiritPermission: 0,
					staffAtte: '',
					standardCode: '',
					standardName: '',
					status: 1,
					surgicalPermission: 0,
					workIdPhoto: ''
				},
				singlePermissionTree: [],
				isEditingDept: false,
				multiPermissionTree: [],
				savingDept: false,
				permissionTree: [
					{ id: 1, label: '精神权限', icon: 'el-icon-s-help', isGroup: true, children: [{ id: 101, label: '精神一类', value: 1 }, { id: 102, label: '精神二类', value: 2 }] },
					{ id: 2, label: '抗生素等级', icon: 'el-icon-first-aid-kit', isGroup: true, children: [{ id: 201, label: '一级抗生素', value: 1 }, { id: 202, label: '二级抗生素', value: 2 }, { id: 203, label: '三级抗生素', value: 3 }] },
					{ id: 3, label: '处方权', icon: 'el-icon-document' },
					{ id: 4, label: '中药处方权', icon: 'el-icon-medal' },
					{ id: 5, label: '麻药权限', icon: 'el-icon-medal-1' },
					{ id: 6, label: '手术权限', icon: 'el-icon-scissors' },
					{ id: 7, label: '毒药权限', icon: 'el-icon-warning' },
					{ id: 8, label: '抗肿瘤药物权限', icon: 'el-icon-first-aid-kit' }
				],
				treeProps: {
					children: 'children',
					label: 'label',
					disabled: (data, node) => this.mode === 'view'
				},
				roleTreeProps: {
					children: 'children',
					label: 'roleName'
				},
				selectedPermissions: { spirit: null, antibiotic: null, others: [] },
				defaultExpandedKeys: [1, 2],
				jobEntities: [
					{ id: 1, label: '群众' }, { id: 2, label: '共青团员' }, { id: 3, label: '中共预备党员' },
					{ id: 4, label: '中共党员' }, { id: 5, label: '民革党员' }, { id: 6, label: '民盟盟员' },
					{ id: 7, label: '民建会员' }, { id: 8, label: '民进会员' }, { id: 9, label: '农工党党员' },
					{ id: 10, label: '致公党党员' }, { id: 11, label: '九三学社社员' }, { id: 12, label: '台盟盟员' },
					{ id: 13, label: '无党派人士' }
				],
				dictData: {
					certypeEntities: [], natyEntities: [], country: [],
					aboTypeEntities: [], mrgStateEntities: [], edulBacdEntities: [], profttlEntities: []
				},
				professionalTitleGroups: [],
				sexOptions: [{ id: 1, label: '男' }, { id: 2, label: '女' }],
				deptTableData: [],
				deptOptions: [],
				showAddDeptDialog: false,
				newDept: { deptName: '', mainDep: 0 },
				staffAtteOption: [{ id: 1, label: '医生' }, { id: 2, label: '护士' }, { id: 3, label: '技师' }, { id: 6, label: '药师' }, { id: 5, label: '其它' }],
				YNOption: [{ id: 1, label: '是' }, { id: 0, label: '否' }],
				updateId: 0,
				areaOptions: [],
				nativePlaceCascader: [],
				cascaderProps: { value: 'areaName', label: 'areaName', children: 'children', lazy: true, lazyLoad: this.loadAreaData },
				submitting: false,
				calculateAge,
				roleOptions: [],
				calculateLunarBirthDate,
				lunarDateDialogVisible: false,
				selectedLunarDate: '',
				selectedSpiritPermission: null,
				selectedAntibioticAuthorization: null,
				rules: {
					fullName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
					sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
					idNumber: [{ required: true, validator: validateIdNumber, trigger: 'blur' }],
					contactNumber: [{ required: true, validator: validatePhone, trigger: 'blur' }],
					professionalTitle: [{ required: true, message: '请选择专业职称', trigger: 'change' }]
				},
				otherRules: {}
			}
		},
		computed: {
			dialogTitle() {
				if (this.mode === 'view') return `检阅${this.form.fullName}的档案详情`
				else if (this.mode === 'edit') return `修改${this.form.fullName}的档案信息`
				else return `为${this.clinicName || '当前诊所'}添加新的人员档案`
			},
			dialogVisible: {
				get() { return this.visible },
				set(value) { if (!value) this.$emit('update:visible', false) }
			},
			age() {
				return this.form.birthDate ? this.calculateAge(this.form.birthDate) : ''
			}
		},
		watch: {
			visible(val) { if (val) this.initDialog() },
			selectedId(val) { if (val && this.visible) this.fetchUserInfo(val) }
		},
		mounted() { this.initData() },
		methods: {
			async initData() {
				await this.fetchDictData()
				await this.fetchDeptOptions()
				this.setClinicId()
				this.groupProfessionalTitles()
			},

			initDialog() {
				if (this.mode === 'add') {
					this.resetForm()
					this.fetchRoleList()
				} else if (this.selectedId && this.mode !== 'add') {
					this.fetchUserInfo(this.selectedId)
				}
				this.isEditingDept = false
			},

			/**
			 * ★ 角色 id 归一化：仅做「去除空白 + 强制字符串」，
			 *   绝不做 Number 转换、绝不做截取。
			 *   依赖 axios 拦截器（transformResponse）在 JSON.parse 前将 16+ 位数字包成字符串，
			 *   因此这里拿到的就是后端原始的 19 位字符串 id，一分不差。
			 */
			normalizeRoleId(raw) {
				if (raw === null || raw === undefined) return ''
				return String(raw).trim()
			},

			/**
			 * ★ 获取角色列表 ★
			 * - roleOptions[i].id = 原始字符串 id（树 node-key）
			 * - 用 Set 去重，防止后端数据异常导致 Duplicate keys
			 */
			async fetchRoleList() {
				try {
					const clinicId = this.form.clinicId
					if (!clinicId) {
						console.warn('诊所ID为空，无法获取角色列表')
						this.roleOptions = []
						return
					}

					const res = await roleList({ clinicId, pageNum: 1, pageSize: 99 })

					let list = []
					if (Array.isArray(res)) list = res
					else if (res && Array.isArray(res.data)) list = res.data
					else if (res && Array.isArray(res.rows)) list = res.rows
					else if (res && res.data && Array.isArray(res.data.records)) list = res.data.records

					const seen = new Set()
					this.roleOptions = list
						.map(item => ({
							...item,
							// ★ 严格字符串：不做 Number 转换，不截取
							id: this.normalizeRoleId(item.id),
							roleName: item.roleName || item.name || ''
						}))
						.filter(item => {
							if (!item.id) return false
							if (seen.has(item.id)) return false
							seen.add(item.id)
							return true
						})

					// 树数据更新完成后回填勾选
					this.$nextTick(() => this.setRoleTreeChecked())
				} catch (error) {
					console.error('获取角色列表失败:', error)
					this.roleOptions = []
				}
			},

			/**
			 * ★ 回填角色树勾选 ★
			 * form.roleId 已是 19 位字符串数组，与 roleOptions[i].id 精准匹配
			 */
			setRoleTreeChecked() {
				if (!this.$refs.roleTree) return
				const keys = Array.isArray(this.form.roleId)
					? this.form.roleId.map(k => this.normalizeRoleId(k)).filter(Boolean)
					: []
				this.$refs.roleTree.setCheckedKeys(keys)
			},

			/**
			 * ★ 角色树勾选变化 ★
			 * getCheckedKeys() 返回字符串数组 → 原样保存到 form.roleId
			 */
			handleRoleTreeCheck() {
				if (!this.$refs.roleTree) return
				const checkedKeys = this.$refs.roleTree.getCheckedKeys()
				this.form.roleId = checkedKeys.map(k => this.normalizeRoleId(k)).filter(Boolean)
			},

			async fetchUserInfo(id) {
				this.updateId = id
				try {
					const res = await getStaff({ id })
					if (res && res.code === 200 && res.data) {
						this.form = {
							...res.data,
							staffAtte: Number(res.data.staffAtte)
						}

						// ★ 详情返回的 roleId → 严格字符串数组（不做 Number/截取，去重）
						let rawRoleIds = []
						if (res.data.roleId) {
							if (Array.isArray(res.data.roleId)) rawRoleIds = res.data.roleId
							else if (typeof res.data.roleId === 'string' && res.data.roleId.trim()) rawRoleIds = res.data.roleId.split(',')
							else if (typeof res.data.roleId === 'number') rawRoleIds = [res.data.roleId]
						}
						const seen = new Set()
						this.form.roleId = rawRoleIds
							.map(r => this.normalizeRoleId(r))
							.filter(r => {
								if (!r) return false
								if (seen.has(r)) return false
								seen.add(r)
								return true
							})

						if (this.form.nativePlace) {
							this.nativePlaceCascader = this.form.nativePlace.split('/')
						}

						if (res.data.deptList && Array.isArray(res.data.deptList)) {
							this.deptTableData = res.data.deptList.map(dept => ({ ...dept, editing: false }))
						}
						this.isEditingDept = false
						this.setPermissionTreeChecked()

						// 角色列表加载完成后，fetchRoleList 内部会自动回填树勾选
						this.fetchRoleList()

						if (this.form.idNumber) this.handleIdNumberBlur()
					} else {
						this.$message.error('获取用户信息失败')
					}
				} catch (error) {
					console.error('获取用户信息失败:', error)
					this.$message.error('获取用户信息失败')
				}
			},

			setClinicId() {
				try {
					const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
					if (userInfo && userInfo.clinicId) this.form.clinicId = userInfo.clinicId
				} catch (error) {
					console.error('获取诊所ID失败:', error)
				}
			},

			async fetchDictData() {
				try {
					const res = await dict()
					if (res.code === 200 && res.data) {
						this.dictData = {
							certypeEntities: res.data.certypeEntities || [],
							natyEntities: res.data.natyEntities || [],
							country: res.data.country || [],
							jobEntities: res.data.jobEntities || [],
							aboTypeEntities: res.data.aboTypeEntities || [],
							mrgStateEntities: res.data.mrgStateEntities || [],
							edulBacdEntities: res.data.edulBacdEntities || [],
							profttlEntities: res.data.profttlEntities || []
						}
					}
				} catch (error) {
					console.error('获取字典数据失败:', error)
				}
			},

			handleMainDeptChange(row) {
				if (row.mainDep === 1) {
					this.deptTableData.forEach(item => {
						if (item.id !== row.id) item.mainDep = 0
					})
				}
			},

			handleDeptRemove(row, index) {
				if (this.mode === 'view') return
				this.$confirm('确定要移除该科室吗？', '提示', {
					confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
				}).then(() => {
					this.deptTableData.splice(index, 1)
					this.$message.success('移除成功')
				})
			},

			groupProfessionalTitles() {
				const titles = this.dictData.profttlEntities || []
				const groups = [
					{ title: '医师', options: titles.filter(item => ['医师', '主治医师', '副主任医师', '主任医师'].some(t => item.name.includes(t))) },
					{ title: '药士/师', options: titles.filter(item => item.name.includes('药')) },
					{ title: '护士/护理', options: titles.filter(item => item.name.includes('护士') || item.name.includes('护理')) },
					{ title: '技师', options: titles.filter(item => item.name.includes('技')) },
					{
						title: '其他', options: titles.filter(item => {
							const n = item.name
							return !(['医师', '主治医师', '副主任医师', '主任医师'].some(t => n.includes(t)) || n.includes('药') || n.includes('护士') || n.includes('护理') || n.includes('技'))
						})
					}
				]
				this.professionalTitleGroups = groups.filter(g => g.options.length > 0)
			},

			async fetchDeptOptions() {
				try {
					const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
					const clinicId = userInfo.clinicId
					if (clinicId) {
						const res = await findAttribute({ clinicId })
						if (res && res.data) this.deptOptions = res.data
					}
				} catch (error) {
					console.error('获取科室选项失败:', error)
				}
			},

			resetForm() {
				this.form = {
					anesthesiaAuthorization: 0, antiTumorPermission: 0, antibioticAuthorization: 0,
					birthDate: '', bloodType: '', chPrescriptionRights: 0, clinicId: null,
					contactAddress: '', contactNumber: '', dateOfEmp: '', deptList: [],
					educationalBackground: '', entryTime: '', fullName: '', idNumber: '', idType: 1,
					lunarBirthDate: '', major: '', maritalStatus: '', minZu: '', nationality: 1,
					nativePlace: '', pcElectronicImage: '', poisonPermission: 0, politicalStatus: '',
					practiceDate: '', practicingNumber: '', prescriptionRights: 0, professionalTitle: '',
					qcElectronicImage: '', qualificationNumber: '', resignationTime: '',
					roleId: [], sex: '', signatureImage: '', spiritPermission: 0, staffAtte: '',
					standardCode: '', standardName: '', status: 1, surgicalPermission: 0, workIdPhoto: ''
				}
				this.deptTableData = []
				this.nativePlaceCascader = []
				this.showAddDeptDialog = false
				this.setClinicId()
				this.$nextTick(() => {
					if (this.$refs.permissionTree) this.$refs.permissionTree.setCheckedKeys([])
					if (this.$refs.roleTree) this.$refs.roleTree.setCheckedKeys([])
				})
				this.isEditingDept = false
			},

			async loadAreaData(node, resolve) {
				const { level, data } = node
				if (level === 0) {
					try {
						const res = await getArea({ areaCode: '', areaLevel: 1, condtion: '' })
						resolve(res && res.data ? res.data.map(a => ({ ...a, leaf: false })) : [])
					} catch (e) { resolve([]) }
				} else if (level === 1) {
					try {
						const res = await getArea({ areaCode: data.areaCode, areaLevel: 2, condtion: 'area_p_code' })
						resolve(res && res.data ? res.data.map(a => ({ ...a, leaf: false })) : [])
					} catch (e) { resolve([]) }
				} else if (level === 2) {
					try {
						const res = await getArea({ areaCode: data.areaCode, areaLevel: 3, condtion: 'area_c_code' })
						resolve(res && res.data ? res.data.map(a => ({ ...a, leaf: true })) : [])
					} catch (e) { resolve([]) }
				}
			},

			handleNativePlaceChange(value) {
				if (value && value.length > 0) this.form.nativePlace = value.join('/')
			},

			handleIdNumberBlur() {
				if (this.form.idNumber && this.form.idNumber.length === 18) {
					const birthDate = this.form.idNumber.substr(6, 8)
					const year = birthDate.substr(0, 4)
					const month = birthDate.substr(4, 2)
					const day = birthDate.substr(6, 2)
					this.form.birthDate = `${year}-${month}-${day}`
					const sexCode = parseInt(this.form.idNumber.substr(16, 1))
					this.form.sex = sexCode % 2 === 1 ? 1 : 2
					this.form.lunarBirthDate = this.calculateLunarBirthDate(this.form.birthDate)
				}
			},

			handleManualSelectLunarDate() {
				if (this.mode === 'view') return
				this.lunarDateDialogVisible = true
			},

			handleLunarDateChange(date) { this.selectedLunarDate = date },

			confirmLunarDate() {
				if (this.selectedLunarDate) {
					try {
						const lunarDate = this.calculateLunarBirthDate(this.selectedLunarDate)
						if (lunarDate) {
							this.form.lunarBirthDate = lunarDate
							this.lunarDateDialogVisible = false
							this.$message.success('农历生日已更新')
						} else {
							this.$message.warning('无法计算农历日期，请检查日期格式')
						}
					} catch (e) {
						this.$message.error('农历日期计算失败')
					}
				} else {
					this.$message.warning('请先选择日期')
				}
			},

			async handleImageUpload(file, field) {
				if (this.mode === 'view') return false
				if (!file.type.startsWith('image/')) {
					this.$message.error('只能上传图片文件!')
					return false
				}
				if (file.size / 1024 / 1024 >= 2) {
					this.$message.error('图片大小不能超过 2MB!')
					return false
				}
				try {
					const formData = new FormData()
					formData.append('file', file)
					const res = await builderImage(formData)
					if (res && res.code === 200 && res.data && res.data.url) {
						this.form[field] = res.data.url
						this.$message.success('上传成功')
					} else {
						this.$message.error('上传失败')
					}
				} catch (e) {
					this.$message.error('上传失败')
				}
				return false
			},

			renderTreeNode(h, { node, data, store }) {
				if (this.mode === 'view') {
					return h('span', { class: 'tree-view-node' }, [
						h('i', { class: data.icon || 'el-icon-document', style: { marginRight: '5px' } }),
						h('span', { class: 'tree-label' }, node.label),
						this.isNodeChecked(node, data) ? h('span', { class: 'view-check-mark' }, ' ✓') : null
					])
				}
				return h('span', { class: 'tree-edit-node' }, [
					h('i', { class: data.icon || 'el-icon-document', style: { marginRight: '5px' } }),
					h('span', {
						class: 'tree-label',
						on: { click: (e) => { e.stopPropagation(); this.handleLabelClick(node, data, e) } }
					}, node.label)
				])
			},

			handleLabelClick(node, data, event) {
				if (this.mode === 'view') return
				event.stopPropagation()
				const tree = this.$refs.permissionTree
				const checkedKeys = tree.getCheckedKeys()
				const isChecked = checkedKeys.includes(data.id)

				if (data.isGroup) {
					if (data.children && data.children.length > 0) this.handleGroupClick(data, data.children[0], tree)
				} else if ([101, 102].includes(data.id)) {
					this.handleSpiritPermissionClick(data, isChecked, tree)
				} else if ([201, 202, 203].includes(data.id)) {
					this.handleAntibioticPermissionClick(data, isChecked, tree)
				} else {
					this.handleOtherPermissionClick(data, isChecked, tree)
				}
			},

			handleGroupClick(group, child, tree) {
				if (group.children) group.children.forEach(c => tree.setChecked(c.id, false))
				tree.setChecked(child.id, true)
				if (group.id === 1) this.form.spiritPermission = child.value
				else if (group.id === 2) this.form.antibioticAuthorization = child.value
			},

			handleSpiritPermissionClick(data, isChecked, tree) {
				if (!isChecked) {
					const otherId = data.id === 101 ? 102 : 101
					tree.setChecked(otherId, false)
					tree.setChecked(data.id, true)
					this.form.spiritPermission = data.value
				} else {
					tree.setChecked(data.id, false)
					this.form.spiritPermission = 0
				}
			},

			handleAntibioticPermissionClick(data, isChecked, tree) {
				if (!isChecked) {
					[201, 202, 203].forEach(id => { if (id !== data.id) tree.setChecked(id, false) })
					tree.setChecked(data.id, true)
					this.form.antibioticAuthorization = data.value
				} else {
					tree.setChecked(data.id, false)
					this.form.antibioticAuthorization = 0
				}
			},

			handleOtherPermissionClick(data, isChecked, tree) {
				tree.setChecked(data.id, !isChecked)
				switch (data.id) {
					case 3: this.form.prescriptionRights = !isChecked ? 1 : 0; break
					case 4: this.form.chPrescriptionRights = !isChecked ? 1 : 0; break
					case 5: this.form.anesthesiaAuthorization = !isChecked ? 1 : 0; break
					case 6: this.form.surgicalPermission = !isChecked ? 1 : 0; break
					case 7: this.form.poisonPermission = !isChecked ? 1 : 0; break
					case 8: this.form.antiTumorPermission = !isChecked ? 1 : 0; break
				}
			},

			handleTreeNodeClick(data, node, treeNode) {
				if (this.mode === 'view') return
			},

			handlePermissionChange(data, checkedState) {
				if (this.mode === 'view') return
				const { checkedKeys, halfCheckedKeys } = checkedState
				this.updatePermissionFormValues([...checkedKeys, ...halfCheckedKeys])
			},

			updatePermissionFormValues(checkedKeys) {
				if (checkedKeys.includes(101)) this.form.spiritPermission = 1
				else if (checkedKeys.includes(102)) this.form.spiritPermission = 2
				else this.form.spiritPermission = 0

				if (checkedKeys.includes(201)) this.form.antibioticAuthorization = 1
				else if (checkedKeys.includes(202)) this.form.antibioticAuthorization = 2
				else if (checkedKeys.includes(203)) this.form.antibioticAuthorization = 3
				else this.form.antibioticAuthorization = 0

				this.form.prescriptionRights = checkedKeys.includes(3) ? 1 : 0
				this.form.chPrescriptionRights = checkedKeys.includes(4) ? 1 : 0
				this.form.anesthesiaAuthorization = checkedKeys.includes(5) ? 1 : 0
				this.form.surgicalPermission = checkedKeys.includes(6) ? 1 : 0
				this.form.poisonPermission = checkedKeys.includes(7) ? 1 : 0
				this.form.antiTumorPermission = checkedKeys.includes(8) ? 1 : 0
			},

			isNodeChecked(node, data) {
				const tree = this.$refs.permissionTree
				if (!tree) return false
				return tree.getCheckedKeys().includes(data.id)
			},

			setPermissionTreeChecked() {
				const checkedKeys = []
				if (this.form.spiritPermission === 1) checkedKeys.push(101)
				else if (this.form.spiritPermission === 2) checkedKeys.push(102)
				if (this.form.antibioticAuthorization === 1) checkedKeys.push(201)
				else if (this.form.antibioticAuthorization === 2) checkedKeys.push(202)
				else if (this.form.antibioticAuthorization === 3) checkedKeys.push(203)
				if (this.form.prescriptionRights === 1) checkedKeys.push(3)
				if (this.form.chPrescriptionRights === 1) checkedKeys.push(4)
				if (this.form.anesthesiaAuthorization === 1) checkedKeys.push(5)
				if (this.form.surgicalPermission === 1) checkedKeys.push(6)
				if (this.form.poisonPermission === 1) checkedKeys.push(7)
				if (this.form.antiTumorPermission === 1) checkedKeys.push(8)

				this.$nextTick(() => {
					if (this.$refs.permissionTree) this.$refs.permissionTree.setCheckedKeys(checkedKeys)
				})
			},

			handleDeptEdit(row, index) {
				if (this.mode === 'view') return
				if (this.isEditingDept) {
					this.$message.warning('请先完成当前编辑或取消')
					return
				}
				this.$set(row, 'originalData', { deptName: row.deptName, deptId: row.deptId, mainDep: row.mainDep })
				row.editing = true
				this.isEditingDept = true
			},

			saveDeptEdit(row, index) {
				if (!row.deptName) {
					this.$message.warning('请选择科室名称')
					return
				}
				const duplicateDept = this.deptTableData.find((dept, i) => dept.deptName === row.deptName && i !== index && !dept.editing)
				if (duplicateDept) {
					this.$message.warning('该科室已存在，请勿重复添加')
					return
				}
				const deptOption = this.deptOptions.find(dept => dept.deptName === row.deptName)
				if (deptOption) row.deptId = deptOption.id
				row.editing = false
				delete row.originalData
				if (row.isNew) delete row.isNew
				this.isEditingDept = false
				this.$message.success('保存成功')
			},

			cancelDeptEdit(row, index) {
				if (row.isNew) this.deptTableData.splice(index, 1)
				else if (row.originalData) {
					Object.assign(row, row.originalData)
					delete row.originalData
				}
				row.editing = false
				this.isEditingDept = false
				if (row.oldData) delete row.oldData
			},

			handleDeptNameChange(row) {
				if (row.deptName) {
					const deptOption = this.deptOptions.find(dept => dept.deptName === row.deptName)
					if (deptOption) row.deptId = deptOption.id
				}
			},

			handleAddDept() {
				if (this.mode === 'view') return
				if (this.isEditingDept) {
					this.$message.warning('请先完成当前编辑或取消')
					return
				}
				const hasMainDept = this.deptTableData.some(dept => dept.mainDep === 1)
				const defaultMainDep = hasMainDept ? 0 : 1
				const newRow = { id: '', deptId: null, deptName: '', mainDep: defaultMainDep, editing: true, isNew: true }
				this.deptTableData.push(newRow)
				this.isEditingDept = true
				this.$nextTick(() => {
					const tableWrapper = this.$refs.deptTable?.$el?.querySelector('.el-table__body-wrapper')
					if (tableWrapper) tableWrapper.scrollTop = tableWrapper.scrollHeight
				})
			},

			async saveNewDept() {
				if (!this.newDept.deptName) {
					this.$message.warning('请选择科室名称')
					return
				}
				this.savingDept = true
				try {
					const deptOption = this.deptOptions.find(dept => dept.deptName === this.newDept.deptName)
					if (!deptOption) {
						this.$message.warning('选择的科室不存在')
						return
					}
					const exists = this.deptTableData.some(dept => dept.deptName === this.newDept.deptName)
					if (exists) {
						this.$message.warning('该科室已存在，请勿重复添加')
						return
					}
					const newDept = {
						id: Date.now(), deptId: deptOption.id || 0, deptName: this.newDept.deptName,
						mainDep: this.newDept.mainDep || 0, editing: true, isNew: true
					}
					if (newDept.mainDep === 1) {
						const hasMainDept = this.deptTableData.some(dept => dept.mainDep === 1)
						if (hasMainDept) {
							this.$confirm('已存在主要科室，是否替换？', '提示', {
								confirmButtonText: '替换', cancelButtonText: '取消', type: 'warning'
							}).then(() => {
								this.deptTableData.forEach(d => { d.mainDep = 0 })
								this.deptTableData.push(newDept)
								this.closeAddDeptDialog()
								this.$message.success('科室添加成功')
							}).catch(() => {
								newDept.mainDep = 0
								this.deptTableData.push(newDept)
								this.closeAddDeptDialog()
								this.$message.success('科室添加成功')
							})
							return
						}
					}
					this.deptTableData.push(newDept)
					this.closeAddDeptDialog()
					this.$message.success('科室添加成功')
				} catch (e) {
					this.$message.error('添加科室失败')
				} finally {
					this.savingDept = false
				}
			},

			closeAddDeptDialog() {
				this.showAddDeptDialog = false
				this.newDept = { deptName: '', mainDep: 0 }
			},

			cancelAddDept() {
				this.showAddDeptDialog = false
				this.newDept = { deptName: '', mainDep: 0 }
			},

			validateForm() {
				return this.$refs.basicForm.validate()
			},

			validateDeptData() {
				if (this.deptTableData.length === 0) {
					this.$message.error('请至少添加一个科室')
					return false
				}
				const editingRow = this.deptTableData.find(dept => dept.editing)
				if (editingRow) {
					this.$message.error(`请先完成"${editingRow.deptName || '新科室'}"的编辑`)
					return false
				}
				const deptNames = []
				for (const dept of this.deptTableData) {
					if (deptNames.includes(dept.deptName)) {
						this.$message.error(`科室"${dept.deptName}"已存在，请勿重复添加`)
						return false
					}
					deptNames.push(dept.deptName)
				}
				const mainDepts = this.deptTableData.filter(d => d.mainDep === 1)
				if (mainDepts.length === 0) {
					this.$message.error('必须设置一个主要科室')
					return false
				}
				if (mainDepts.length > 1) {
					this.$message.error('只能设置一个主要科室')
					return false
				}
				return true
			},

			/**
			 * ★ 提交 ★
			 * 提交前从树里取最新勾选（字符串 19 位原始 id），直接提交给后端
			 */
			async handleSubmit(modeType) {
				try {
					const isFormValid = await this.validateForm()
					if (!isFormValid) return
					if (!this.validateDeptData()) return

					this.submitting = true

					// 提交前从树里再同步一次（拿到最新勾选的字符串 id 数组）
					if (this.$refs.roleTree) {
						const checkedKeys = this.$refs.roleTree.getCheckedKeys()
						this.form.roleId = checkedKeys.map(k => this.normalizeRoleId(k)).filter(Boolean)
					}

					const submitData = {
						// id: this.updateId,
						anesthesiaAuthorization: this.form.anesthesiaAuthorization || 0,
						antiTumorPermission: this.form.antiTumorPermission || 0,
						antibioticAuthorization: this.form.antibioticAuthorization || 0,
						birthDate: this.form.birthDate || '',
						bloodType: this.form.bloodType || '',
						chPrescriptionRights: this.form.chPrescriptionRights || 0,
						clinicId: this.form.clinicId || 0,
						contactAddress: this.form.contactAddress || '',
						contactNumber: this.form.contactNumber || '',
						dateOfEmp: this.form.dateOfEmp || '',
						deptList: this.deptTableData.map(dept => ({
							deptId: dept.deptId || 0,
							deptName: dept.deptName || '',
							mainDep: dept.mainDep || 0
						})),
						educationalBackground: this.form.educationalBackground || '',
						entryTime: this.form.entryTime || '',
						fullName: this.form.fullName || '',
						idNumber: this.form.idNumber || '',
						idType: this.form.idType || 0,
						lunarBirthDate: this.form.lunarBirthDate || '',
						major: this.form.major || '',
						maritalStatus: this.form.maritalStatus || '',
						minZu: this.form.minZu || '',
						nationality: this.form.nationality || '',
						nativePlace: this.form.nativePlace || '',
						pcElectronicImage: this.form.pcElectronicImage || '',
						poisonPermission: this.form.poisonPermission || 0,
						politicalStatus: this.form.politicalStatus || '',
						practiceDate: this.form.practiceDate || '',
						practicingNumber: this.form.practicingNumber || '',
						prescriptionRights: this.form.prescriptionRights || 0,
						professionalTitle: this.form.professionalTitle || '',
						qcElectronicImage: this.form.qcElectronicImage || '',
						qualificationNumber: this.form.qualificationNumber || '',
						resignationTime: this.form.resignationTime || '',
						// ★ 提交 19 位原始字符串 id 数组，未做任何截取/Number 转换
						roleId: (this.form.roleId || []).map(k => this.normalizeRoleId(k)).filter(Boolean),
						sex: this.form.sex || 0,
						signatureImage: this.form.signatureImage || '',
						spiritPermission: this.form.spiritPermission || 0,
						staffAtte: this.form.staffAtte || '',
						standardCode: this.form.standardCode || '',
						standardName: this.form.standardName || '',
						status: this.form.status || 1,
						surgicalPermission: this.form.surgicalPermission || 0,
						workIdPhoto: this.form.workIdPhoto || ''
					}

					let res
					if (modeType === 'add') res = await addStaff(submitData)
					else res = await updateStaff(submitData)

					if (res && res.code === 200) {
						const message = modeType === 'add'
							? `当前诊所${this.clinicName}已添加完成新的人员信息！`
							: '人员档案信息更新成功！'
						this.$message.success(message)
						this.$emit('success')
						this.handleClose()
					} else {
						this.$message.error(res?.message || '提交失败')
					}
				} catch (error) {
					console.error('提交失败:', error)
					this.$message.error('请先完成对应字段的填写！')
				} finally {
					this.submitting = false
				}
			},

			handleClose() {
				this.isEditingDept = false
				this.$emit('close')
			}
		}
	}
</script>

<style lang="less" scoped>
	/deep/ .new-acc-dialog {
		border-radius: 10px;

		.el-dialog__header {
			background: linear-gradient(135deg, #0075ab 0%, #004a6c 100%);
			padding: 10px 10px 10px;
			border-top-left-radius: 10px;
			border-top-right-radius: 10px;
			position: relative;
			overflow: hidden;

			&:before {
				content: '';
				position: absolute;
				top: 0; left: 0; right: 0; bottom: 0;
				background: rgba(255, 255, 255, 0.1);
				z-index: 1;
			}

			.el-dialog__title {
				color: white;
				font-size: 14px;
				font-weight: 600;
				position: relative;
				z-index: 2;
				text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
			}

			.el-dialog__headerbtn {
				position: absolute;
				top: 16px;
				right: 20px;
				z-index: 2;

				.el-dialog__close {
					color: white;
					font-size: 16px;
					&:hover { color: #f0f0f0; }
				}
			}
		}

		.el-dialog__body { padding: 20px; font-size: 12px; }
		.el-dialog__footer {
			border-bottom-left-radius: 10px;
			border-bottom-right-radius: 10px;
			background: #f5f7fa;
		}
	}

	/deep/ .el-select-dropdown__item { font-size: 12px; }
	/deep/ .el-select-group__title {
		font-size: 12px; color: #fff; font-weight: bold; background-color: #a4c9da;
	}
	/deep/ .el-upload { display: block; }

	.new-acc-son-container {
		height: 70vh;
		overflow: hidden;
		font-size: 12px;

		.layout-container {
			display: flex;
			height: 100%;
			gap: 12px;

			.left-panel,
			.right-panel {
				background: #fff;
				border-radius: 8px;
				border: 1px solid #ebeef5;
				display: flex;
				flex-direction: column;
				overflow: hidden;
				box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
			}

			.left-panel { flex: 1.5; min-width: 15%; }

			.middle-panel {
				flex: 6;
				display: flex;
				flex-direction: column;
				gap: 12px;
				overflow-y: auto;
			}

			.right-panel {
				display: flex;
				flex-direction: column;
				height: 100%;
				gap: 8px;
				overflow: hidden;

				.role-permission-section {
					flex: 0 0 30%;
					display: flex;
					flex-direction: column;
					overflow: hidden;
					border: 1px solid #ebeef5;
					border-radius: 8px;
					background: white;

					.panel-content {
						flex: 1;
						overflow: auto;
						padding: 8px 12px;

						/* ★ 角色树样式 ★ */
						.role-tree {
							background: transparent;

							/deep/ .el-tree-node__content {
								height: 30px;
								line-height: 30px;
								border-radius: 4px;

								&:hover { background-color: #f5f7fa; }
							}

							/deep/ .el-checkbox__inner {
								width: 15px;
								height: 15px;
							}

							/deep/ .el-tree-node__label {
								font-size: 12px;
								color: #606266;
							}

							/deep/ .el-tree-node.is-checked > .el-tree-node__content {
								background-color: #f0f9ff;

								.el-tree-node__label { color: #409eff; font-weight: 500; }
							}
						}
					}
				}

				.dept-info-section {
					flex: 1;
					display: flex;
					flex-direction: column;
					overflow: hidden;
					border: 1px solid #ebeef5;
					border-radius: 8px;
					background: white;

					.panel-content {
						flex: 1;
						overflow: hidden;
						padding: 0;
						display: flex;
						flex-direction: column;

						.el-table {
							flex: 1;

							/deep/ .el-table__body-wrapper {
								max-height: calc(100% - 100px);
								overflow-y: auto;
							}
						}
					}
				}
			}

			.panel-header {
				padding: 12px;
				border-bottom: 1px solid #ebeef5;
				background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
				display: flex;
				justify-content: space-between;
				align-items: center;

				.module-title {
					margin: 0;
					font-size: 14px;
					font-weight: 700;
					color: #303133;
					position: relative;
					padding-left: 10px;

					&:before {
						content: '';
						position: absolute;
						left: 0;
						top: 50%;
						transform: translateY(-50%);
						width: 4px;
						height: 16px;
						background: #409eff;
						border-radius: 2px;
					}
				}

				.el-button { font-size: 12px; }
			}

			.panel-content {
				flex: 1;
				overflow-y: auto;
				padding: 12px;

				/deep/ .el-tree {
					width: 100%;

					.el-tree-node__content {
						height: 32px;

						&:hover { background-color: #f5f7fa; }

						.tree-label {
							cursor: pointer;
							user-select: none;
							padding: 2px 5px;
							border-radius: 3px;
							transition: all 0.2s;

							&:hover { background-color: #ecf5ff; color: #409eff; }
						}
					}

					.el-tree-node.is-current > .el-tree-node__content {
						background-color: #ecf5ff;
						.tree-label { color: #409eff; font-weight: 500; }
					}

					.el-checkbox__inner { width: 16px; height: 16px; }
				}
			}
		}

		.form-section {
			background: #fff;
			border-radius: 8px;
			border: 1px solid #ebeef5;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

			.section-header {
				padding: 12px;
				border-bottom: 1px solid #ebeef5;
				background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);

				.module-title {
					margin: 0;
					font-size: 14px;
					font-weight: 700;
					color: #303133;
					position: relative;
					padding-left: 10px;

					&:before {
						content: '';
						position: absolute;
						left: 0;
						top: 50%;
						transform: translateY(-50%);
						width: 4px;
						height: 16px;
						background: #409eff;
						border-radius: 2px;
					}
				}
			}

			.basic-form,
			.other-form {
				padding: 20px;

				.el-row { margin-bottom: 12px; }
				.el-form-item { margin-bottom: 12px; }

				/deep/ .el-form-item__label {
					font-size: 12px;
					font-weight: 500;
				}

				.el-input__inner,
				.el-select,
				.el-cascader,
				.el-date-editor { font-size: 12px; }
			}

			.certificate-images {
				padding: 20px;
				display: grid;
				grid-template-columns: repeat(2, 1fr);
				gap: 20px;

				.image-item {
					.image-title {
						font-size: 12px;
						font-weight: 500;
						color: #606266;
						margin-bottom: 8px;
						text-align: center;
					}

					.image-uploader {
						width: 100%;
						display: block !important;

						.image-container {
							width: 100%;
							height: 120px;
							border: 2px dashed #dcdfe6;
							border-radius: 6px;
							display: flex;
							align-items: center;
							justify-content: center;
							overflow: hidden;
							cursor: pointer;
							transition: all 0.3s;

							&:hover {
								border-color: #409eff;
								transform: translateY(-2px);
								box-shadow: 0 4px 8px rgba(64, 158, 255, 0.2);
							}

							.certificate-image {
								width: 100%;
								height: 100%;
								object-fit: cover;
							}

							.image-empty {
								color: #c0c4cc;
								text-align: center;

								i { font-size: 24px; margin-bottom: 8px; display: block; }
								div { font-size: 12px; }
							}
						}
					}
				}
			}
		}

		.add-dept-dialog {
			margin-top: 12px;
			padding: 12px;
			border: 1px dashed #dcdfe6;
			border-radius: 4px;

			.dept-form {
				display: flex;
				gap: 8px;
				margin-bottom: 12px;
				.el-select { font-size: 12px; }
			}

			.dept-actions {
				display: flex;
				justify-content: flex-end;
				gap: 8px;
				.el-button { font-size: 12px; }
			}
		}
	}

	.dialog-footer {
		display: flex;
		justify-content: flex-end;
		gap: 12px;
		.el-button { font-size: 12px; }
	}

	.lunar-date-picker {
		.lunar-date-actions {
			display: flex;
			justify-content: flex-end;
			gap: 12px;
			margin-top: 20px;
		}
	}

	@media (max-width: 1200px) {
		.new-acc-son-container {
			.layout-container {
				.left-panel { flex: 1; min-width: 150px; }
				.middle-panel { flex: 2; min-width: 300px; }
				.right-panel { flex: 1; min-width: 150px; }
			}

			.basic-form,
			.other-form {
				.el-row {
					.el-col { margin-bottom: 10px; }
				}
			}
		}
	}
</style>

<style lang="less" scoped>
	.permission-tree-section {
		height: 100%;
		overflow-y: auto;
		padding: 0 8px;

		.custom-permission-tree {
			/deep/ .el-tree {
				.el-tree-node {
					.el-tree-node__content {
						height: 30px;
						line-height: 30px;
						position: relative;

						&:hover { background-color: #f5f7fa; }

						.el-checkbox { margin-right: 8px; }

						.tree-node-content {
							display: flex;
							align-items: center;
							width: 100%;
							cursor: pointer;

							.tree-icon {
								margin-right: 8px;
								color: #409eff;
								font-size: 14px;
								flex-shrink: 0;
							}

							.tree-label {
								flex: 1;
								font-size: 12px;
								color: #606266;
								user-select: none;

								&.view-mode-label {
									padding-right: 20px;
									position: relative;
								}

								.view-check-mark {
									position: absolute;
									right: 0;
									top: 50%;
									transform: translateY(-50%);
									color: #67c23a;
									font-weight: bold;
									font-size: 14px;
								}
							}
						}
					}

					&.is-checked > .el-tree-node__content {
						background-color: #f0f9ff;
						.tree-node-content { .tree-label { color: #409eff; } }
					}
				}
			}
		}

		.tree-view-node {
			display: flex;
			align-items: center;
			width: 100%;

			i { margin-right: 8px; color: #909399; }

			.tree-label { flex: 1; font-size: 12px; color: #606266; }

			.view-check-mark {
				margin-left: 8px;
				color: #67c23a;
				font-weight: bold;
			}
		}

		.tree-edit-node {
			display: flex;
			align-items: center;
			width: 100%;

			i { margin-right: 8px; color: #409eff; }

			.tree-label {
				flex: 1;
				font-size: 12px;
				color: #606266;
				cursor: pointer;
				padding: 2px 4px;
				border-radius: 3px;

				&:hover { background-color: #ecf5ff; color: #409eff; }
			}
		}

		.el-divider__text {
			font-size: 12px;
			color: #909399;
			background-color: #f5f7fa;
			padding: 0 10px;
		}
	}
</style>